import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import api from '../services/api'
import LoadingSpinner from '../components/LoadingSpinner'
import WindRoseOption4 from '../components/WindRoseOption4'
import { sitesForWindRose } from '../utils/windDirections'
import { useAuth } from '../contexts/AuthContext'
import './WindRosePage.css'

function WindRosePage() {
  const [sites, setSites] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const navigate = useNavigate()
  const { isAuthenticated } = useAuth()

  useEffect(() => {
    let active = true
    ;(async () => {
      try {
        setLoading(true)
        setError(null)
        const data = await api.sites.getAllSites()
        const visible = isAuthenticated ? data : data.filter((s) => !s.possible_site)
        if (active) setSites(sitesForWindRose(visible))
      } catch (err) {
        if (active) setError(err.message)
      } finally {
        if (active) setLoading(false)
      }
    })()
    return () => {
      active = false
    }
  }, [isAuthenticated])

  const handleSiteClick = (site) => {
    if (site.site_id) navigate(`/sites/${site.site_id}`)
  }

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Wind Rose</h1>
        <p>Find flyable sites by wind direction</p>
      </div>

      <div className="wind-rose-page">
        {loading && <LoadingSpinner size="large" message="Loading sites..." />}

        {error && !loading && (
          <div className="error-message">
            <p>Could not load the wind rose: {error}</p>
          </div>
        )}

        {!loading && !error && sites.length === 0 && (
          <p className="wind-rose-empty">No sites with wind-direction data are available yet.</p>
        )}

        {!loading && !error && sites.length > 0 && (
          <>
            <WindRoseOption4 sites={sites} onSiteClick={handleSiteClick} />
            <p className="wind-rose-note">
              Each coloured arc is a flying site, positioned at the wind directions it
              works in. Hover a compass point on the outer ring to preview the sites
              flyable in that wind (click to lock it); the list beside the rose filters
              to match. Click a site to open its guide. Not every site appears here; see
              the <a href="/sites">full sites guide</a> for the complete list.
            </p>
          </>
        )}
      </div>
    </div>
  )
}

export default WindRosePage
